export const UPDATE_ASSISTANCE_OPTIONS = 'updateAssistanceOptions'
export const UPDATE_DASHBOARD_ASSISTANCE_TYPE_FILTER_OPTIONS =
  'updateDashboardAssistanceTypeFilterOptions'
export const UPDATE_CUSTOMER_OPTIONS_ADDITIONAL_INFO =
  'updateCustomerOptionsAdditionalInfo'
export const SET_OTHER_ASSISTANCE_CATEGORIES_GRID =
  'setOtherAssistanceCategoriesGrid'
export const UPDATE_JOURNEY_LIST = 'updateJourneyList'
export const UPDATE_RESULTS_LIST = 'updateResultsList'
export const RESET_JOURNEY_LIST = 'resetJourneyList'
export const RESET_JOURNEY_LIST_BY_DIRECTION = 'resetJourneyListByDirection'
export const RESET_REPLAN_JOURNEY_LIST_BY_DIRECTION =
  'resetReplanJourneyListByDirection'
export const RESET_JOURNEY_PLANNER = 'resetJourneyPlanner'
export const RESET_JOURNEY_PLANNER_BY_DIRECTION =
  'resetJourneyPlannerByDirection'
export const TOGGLE_LOADING = 'toggleLoading'
export const TOGGLE_LOADING_BY_DIRECTION = 'toggleLoadingByDirection'
export const UPDATE_METADATA = 'updateMetadata'
export const UPDATE_METADATA_BY_DIRECTION = 'updateMetadataByDirection'
export const UPDATE_EXTRA_LEGS_METADATA = 'updateExtraLegsMetadata'
export const UPDATE_LEG_ASSISTANCE = 'updateLegAssistance'
export const UPDATE_OUTWARD_JOURNEY = 'updateOutwardJourney'
export const UPDATE_INWARD_JOURNEY = 'updateInwardJourney'
export const UPDATE_LEG_ASSISTANCE_LIST = 'updateLegAssistanceList'
export const UPDATE_BOOKING = 'updateBooking'
export const UPDATE_BOOKINGS = 'updateBookings'
export const UPDATE_ASSISTANCE_COPY_STATUS = 'updateAssistanceCopyStatus'
export const CLEAR_BOOKING = 'clearBooking'
export const INITIALIZE_BOOKING = 'initializeBooking'
export const UPDATE_QUERY = 'updateQuery'
export const UPDATE_DATE = 'updateDate'
export const UPDATE_ORIGINAL_BOOKING = 'updateOriginalBooking'
export const CLEAR_RESERVATION = 'clearReservation'
export const SET_LAST_REFRESH_TIME = 'setLastRefreshTime'
export const SET_REFRESH_POPUP_DISMISS_TIME = 'setRefreshPopupDismissTime'
export const UPDATE_ROUTES = 'updateRoutes'
export const RESET_ADDITIONAL_OPTIONS = 'resetAdditionalOptions'
export const UPDATE_ADD_LEG_RESULTS_LIST = 'updateAddLegResultsList'
export const UPDATE_EXISTING_ADD_LEG_RESULTS_LIST =
  'updateExistingAddLegResultsList'
export const UPDATE_EXTRA_JOURNEY = 'updateExtraJourney'
export const ADD_LEGS_TO_RESULTS = 'addLegsToResults'
export const RESET_EXTRA_JOURNEY_LIST = 'resetExtraJourneyList'
export const RESET_EXTRA_JOURNEY_PLANNER = 'resetExtraJourneyPlanner'
export const UPDATE_EMPTY_OUTWARD_INWARD = 'updateEmptyOutwardInward'
export const UPDATE_MULTI_JOURNEY_RESULTS_LIST = 'updateMultiJourneyResultsList'
export const UPDATE_MULTI_JOURNEY_RESULTS_LIST_BY_DIRECTION =
  'updateMultiJourneyResultsListByDirection'
export const UPDATE_MULTI_ADD_LEG_RESULTS_LIST = 'updateMultiAddLegResultsList'
export const UPDATE_TAB_INDEX = 'updateTabIndex'
export const UPDATE_CHECK_IN = 'updateCheckIn'
export const CHECK_IN_ERROR = 'checkInError'
export const CLEAR_CHECK_IN = 'clearCheckIn'
